import styled from 'styled-components'

export const StyledMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #D4D4D6;
  background: #FFF;
  margin-bottom: 12px;

  position: relative;
`

export const StyledImageAndDetails = styled.div`
  display: grid;
  grid-template-columns: 116px 1fr;
  column-gap: 12px;
`

export const StyledWidgetsContainer = styled.div`
  display: grid;
  gap: 8px;
  margin: 16px 0 0 0;
`

export const StyledQuantityPrice = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0 8px 0;
  align-items: center;
`

export const StyledImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-48-px, 8px);
`

